import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { handleResponse } from 'actions/actionHelpers';
import { fetchIloqSecurityAccessesForRealEstate } from 'actions/iloq';
import { required } from 'form/validation';

import { TextField, showErrorOnBlur } from 'mui-rff';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';

const IloqStorageGroupLockConfigurationDataField = ({ name, label, storageSiteLockConfiguration }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [securityAccesses, setSecurityAccesses] = useState(undefined);

    useEffect(() => {
        let mounted = true;
        if(storageSiteLockConfiguration?.realEstateId) {
            setIsLoading(true);
            dispatch(fetchIloqSecurityAccessesForRealEstate(storageSiteLockConfiguration.realEstateId))
                .then(handleResponse(
                    response => {
                        if(mounted) {
                            setSecurityAccesses(response.payload);
                            setIsLoading(false);
                        }
                    },
                    () => {
                        if(mounted) {
                            setIsLoading(false);
                        }
                    }
                ));
        } else {
            setIsLoading(false);
        }
        return () => {
            mounted = false;
        };
    }, [storageSiteLockConfiguration?.realEstateId]);

    if(isLoading) {
        return (
            <CircularProgress
                size={16}
                color="primary"
            />
        );
    }

    return (
        <TextField
            select
            name={name}
            label={label}
            size="small"
            variant="outlined"
            required
            fieldProps={{ validate: required }}
            showError={showErrorOnBlur}
        >
            {
                (securityAccesses ?? []).map(o =>
                    <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>
                )
            }
        </TextField>
    );
};

IloqStorageGroupLockConfigurationDataField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    storageSiteLockConfiguration: PropTypes.object
};

export default IloqStorageGroupLockConfigurationDataField;
